import { Form } from 'formik';
import styled from 'styled-components';
import { Modal } from 'react-bootstrap';

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  margin-top: 215px;
  width: 100%;
  max-width: 440px;

  @media (max-width: 768px) {
    margin-top: 0;
    place-self: center;
    min-height: calc(100vh - 356px);
    height: 100%;
  }
`;

export const ContainerButtons = styled.div`
  max-width: 440px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  margin-top: 30px;
  display: grid;
  row-gap: 10px;
  margin-bottom: 20px;

  a {
    text-decoration: none;
    width: 100%;
  }
`;

export const FormContainer = styled(Form)`
  width: 100%;

  @media (max-width: 768px) {
    margin-top: 0;
  }
`;

export const RadioContent = styled.div`
  width: 100%;

  > div {
    width: 100%;

    input {
      display: none;
    }

    label {
      background-color: ${({ active }) => (active ? '#000FFF' : 'transparent')};
      border: 1px
        ${({ active }) =>
          active ? 'solid #000FFF' : 'dashed rgba(0, 0, 0, 0.1)'};
      border-left: ${({ active }) =>
        active ? '3px solid #00FF00' : '1px dashed rgba(0, 0, 0, 0.1)'};
      border-radius: 5px;
      width: 100%;
      padding: 25px 5px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: ${({ active }) => (active ? 'white' : '#7A7A7A')};

      @media (max-width: 768px) {
        flex-direction: column;
        align-items: flex-start;
        padding: 15px;
      }

      div {
        display: flex;
        align-items: center;
        font-weight: 700;
        font-size: 16px;
        flex: 1;

        svg {
          font-size: 25px;
          margin-right: 5px;
        }
      }

      > span {
        font-weight: 400;
        font-size: 20px;
      }
    }
  }
`;

export const Error = styled.span`
  color: #dc3545;
`;

export const ModalContainer = styled.div`
  padding: 28px 28px 39px 28px;
  max-width: 620px;
  width: 620px;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const DescriptionWrap = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const ModalHeader = styled.header`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 36px;

  span {
    color: ${({ theme }) => theme.colors.darkBlue};
    font-size: 20px;
  }

  svg {
    color: ${({ theme }) => theme.colors.darkBlue};
  }
`;

export const ModalBody = styled.div`
  color: ${({ theme }) => theme.colors.black};
  font-size: 1.125rem;
  max-width: 536px;
  margin-bottom: 36px;
`;

export const ModalFooter = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 1rem;

  span {
    font-weight: bold;
    color: ${({ theme }) => theme.colors.black};
    margin-bottom: 21px;
  }

  a {
    color: ${({ theme }) => theme.colors.darkBlue};
    text-decoration: none;
    cursor: pointer;
  }

  a:first-child {
    margin-bottom: 12px;
  }
`;

export const ModalStyle = styled(Modal)`
  .modal-content {
    max-width: 620px;
    width: auto;
  }
`;

export const TextContact = styled.span`
  color: ${({ theme }) => theme.colors.blue};
  font-size: 14px;
  text-align: center;
`;

export const OpenModalQuestionsWrap = styled.span`
  color: ${({ theme }) => theme.colors.blue};
  font-family: 'Mangueira', sans-serif;
  text-align: center;
  display: inline-flex;
  text-decoration: underline;
  margin-top: 16px;
  cursor: pointer;
`;
